
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import TextboxField from '@/components/validateFields/TextboxField.vue'
import InputOnlyNumber from '@/components/common/InputOnlyNumber.vue'
import { IProjectCustomField } from '@/utils/types'
import { ECustomFieldUnitPosition } from '@/utils/enums'

@Options({
  components: { TextboxField, InputOnlyNumber },
  name: 'Number',
})
export default class Number extends Vue {
  @Prop({ type: Object }) readonly customField!: IProjectCustomField

  get positionTypes(): Record<string, string> {
    return {
      [ECustomFieldUnitPosition.PREFIX]: 'prefix',
      [ECustomFieldUnitPosition.SUFFIX]: 'suffix',
    }
  }

  mounted() {
    if (this.customField.position === ECustomFieldUnitPosition.UNKNOWN) {
      this.customField.position = ECustomFieldUnitPosition.DEFAULT
    }
  }
}
